import styled from 'styled-components'
import { BrgButton, Colors, FlexBox } from '@brg/ui'
import { LayoutConst } from 'core/modules'

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  max-width: calc(100vw - 32px);
  background: #343434;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    padding: 16px 16px 24px;
  }
`

export const ModalHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: #fff;
  flex: 1;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`

export const CloseButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &:hover svg path {
    fill: #151514;
  }
`

export const ModalDescription = styled.p`
  margin: 0 0 32px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #151514;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 24px;
  }
`

export const ModalActions = styled(FlexBox)`
  width: 100%;
  margin-top: 24px;
  flex-flow: column;
  gap: 8px;
`

export const ModalHollowButton = styled(BrgButton)`
  color: ${Colors.geoWhite100} !important;
  border-color: ${Colors.geoWhite100} !important;

  &:hover {
    border-color: ${Colors.geoWhite47} !important;
  }
`

export const ModalFilledButton = styled(BrgButton)<{ red?: boolean }>`
  color: ${({ red }) => red ? '#fff' : Colors.galBlack100} !important;
  background-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite100} !important;
  border-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite100} !important;

  &:hover {
    background-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite73} !important;
    border-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite73} !important;
  }
`

export const FoldersColumnContainer = styled(FlexBox)`
  flex-flow: column;
  gap: 8px;

  max-height: 500px;
  overflow-y: auto;
`import styled from 'styled-components'
import { BrgButton, Colors, FlexBox } from '@brg/ui'
import { LayoutConst } from 'core/modules'

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  max-width: calc(100vw - 32px);
  background: #343434;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    padding: 16px 16px 24px;
  }
`

export const ModalHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: #fff;
  flex: 1;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`

export const CloseButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &:hover svg path {
    fill: #151514;
  }
`

export const ModalDescription = styled.p`
  margin: 0 0 32px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #151514;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 24px;
  }
`

export const ModalActions = styled(FlexBox)`
  width: 100%;
  margin-top: 24px;
  flex-flow: column;
  gap: 8px;
`

export const ModalHollowButton = styled(BrgButton)`
  color: ${Colors.geoWhite100} !important;
  border-color: ${Colors.geoWhite100} !important;

  &:hover {
    border-color: ${Colors.geoWhite47} !important;
  }
`

export const ModalFilledButton = styled(BrgButton)<{ red?: boolean }>`
  color: ${({ red }) => red ? '#fff' : Colors.galBlack100} !important;
  background-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite100} !important;
  border-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite100} !important;

  &:hover {
    background-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite73} !important;
    border-color: ${({ red }) => red ? '#C64839' : Colors.geoWhite73} !important;
  }
`

export const FoldersColumnContainer = styled(FlexBox)`
  flex-flow: column;
  gap: 8px;

  max-height: 500px;
  overflow-y: auto;
`